// extracted by mini-css-extract-plugin
module.exports = {"table":"RoomCard_table__iq1eD","heavy_cell":"RoomCard_heavy_cell__zPOXX","removed_cell":"RoomCard_removed_cell__xBczu","quantity_cell":"RoomCard_quantity_cell__Qwjlj"};